import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { UserListInterface } from '../types/user-list';
import {
  UserListFilter,
  defaultUserListFilter,
} from '../types/user-list-filter';

export const USER_LIST_STATE = 'userList';

export interface UserListState {
  filter: UserListFilter;
  dataSource: DataSource<UserListInterface[]>;
}

export const initialDataSource: DataSource<UserListInterface[]> = Object.freeze(
  {
    ...initialPageableData,
    rawData: [],
  }
);

export const initialUserListState: UserListState = Object.freeze({
  filter: defaultUserListFilter,
  dataSource: {
    ...initialDataSource,
  },
});
